import React, { useMemo } from 'react';
import RateTableRolesDropdown from './RateTableRolesDropdown';
import { getHelperAndTooltip } from './utils';

export const ResourceRoleDropdown = props => {
  const propOverrides = useMemo(
    () => ({
      getHelperAndTooltip: ({ intl, selectedRole }) =>
        getHelperAndTooltip({ intl, selectedRole, isTaskRole: false })
    }),
    []
  );

  return <RateTableRolesDropdown {...props} propOverrides={propOverrides} />;
};

export default ResourceRoleDropdown;
